import React from 'react';
import cn from 'classnames';

import styles from './Footer.module.scss';

export default function Footer(props) {
  return (
    <div className={cn(styles.content_box, 'footer')}>
      <div className={styles.flex_col}>
        <div className={styles.flex_row}>
          <div className={styles.flex_row__cell}>
            <img src={require('assets/c592f16bf2b135bb5a03643693b29ddf.png')} alt="alt text" className={styles.icon} />
          </div>
          <div className={styles.flex_row__cell1}>
            <h5 className={styles.highlights}>44 E 3rd Ave, San Mateo, CA 94401</h5>
          </div>
        </div>

        <div className={styles.flex_row1}>
          <div className={styles.flex_row1__cell}>
            <img
              src={require('assets/d80b22dfcd09927e38ce0ad4d9336201.png')}
              alt="alt text"
              className={styles.image2}
            />
          </div>
          <h5 className={styles.highlights1}>(650) 427-9813</h5>
        </div>

        <div className={styles.flex_row2}>
          <div className={styles.flex_row2__cell}>
            <img
              src={require('assets/9237ae1bee812b14cb2d125a938d1b3d.png')}
              alt="alt text"
              className={styles.image3}
            />
          </div>
          <div className={styles.flex_row2__spacer} />
          <div className={styles.flex_row2__cell1}>
            <img src={require('assets/3069283d397929f07b6defe22fde7468.png')} alt="alt text" className={styles.icon1} />
          </div>
          <div className={styles.flex_row2__spacer1} />
          <div className={styles.flex_row2__cell2}>
            <img src={require('assets/8c87398acd1c1a9d1603a0f5896e16a4.png')} alt="alt text" className={styles.icon2} />
          </div>
        </div>
      </div>
    </div>
  );
}
